import { useRef, useState, useEffect } from "react";
import {
  Box,
  FormControl,
  Typography,
  Card,
  Alert,
  Stack,
} from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import { useAuthenticate } from "../hooks";
import OTPInput from "react-otp-input";
import { LoadingButton } from "../../../shared";

// --- Move ResendCodeButton OUTSIDE the main component ---
function ResendCodeButton({ resendOtp, isResendBtnBusy }) {
  const [timer, setTimer] = useState(30);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (disabled) {
      const countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(countdown);
            setDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [disabled]);

  const handleResend = async () => {
    const success = await resendOtp();

    if (success) {
      setDisabled(true);
      setTimer(30);
    }
  };

  return (
    <Typography
      onClick={() => {
        !disabled && !isResendBtnBusy && handleResend();
      }}
      variant="subtitle2"
      sx={{
        textTransform: "none",
        color: disabled ? "#808080" : "#1560D4",
        ml: "auto",
        cursor: disabled ? "none" : "pointer",
      }}
    >
      {disabled ? `RESEND in ${timer}s` : "RESEND CODE"}
    </Typography>
  );
}

export function TwoFactorAuthentication() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const { state, handleOTPInput, handleVerifyOTP, resendOtp } =
    useAuthenticate();

  const { otp, isBusy, error, isResendBtnBusy } = state.twoFA;

  return (
    <>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleVerifyOTP();
        }}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Card align="center" sx={{ width: 424 }}>
          <Stack gap="12px" p="24px">
            <img
              alt="lock"
              src="/icons/ic_otp.svg"
              style={{ height: "47px" }}
            />
            <Typography variant="h5">Two-Factor Authentication</Typography>
            <Typography variant="subtitle2">
              A 4-digit verification code was sent to your{" "}
              {type === "phone" ? "mobile" : "email"}. Please enter it below to
              continue.
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p: "24px 10px 0",
                gap: "16px",
              }}
            >
              <OTPInput
                value={otp}
                onChange={handleOTPInput}
                numInputs={4}
                renderInput={(props) => (
                  <input
                    {...props}
                    className={`otp-input ${error ? "otp-error" : ""}`}
                  />
                )}
                containerStyle={{
                  gap: "16px",
                }}
              />
              {error && (
                <Typography color="#ff0000" variant="subtitle2">
                  {error}
                </Typography>
              )}
              {/* Pass props to ResendCodeButton */}
              <ResendCodeButton
                resendOtp={resendOtp}
                isResendBtnBusy={isResendBtnBusy}
              />
            </Box>

            <LoadingButton
              color="primary"
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              loading={isBusy}
              disabled={otp.length < 4}
              onClick={handleVerifyOTP}
            >
              Verify
            </LoadingButton>
            <Typography
              variant="subtitle2"
              color="#808080"
              textAlign="left"
              my="4px"
            >
              Use a different Account?{" "}
              <Link
                to="/authentication/login"
                style={{
                  color: "#1560D4",
                  textDecoration: "none",
                }}
              >
                {" "}
                Go to Login
              </Link>
            </Typography>
          </Stack>
        </Card>
      </Box>
    </>
  );
}
